import { useGetStationTasks, type StationView } from '@ordr-as/ordr-service-types/epos';
import { useOrdersWebSocketStore } from '../context/OrdersWebSocketStore';

/**
 * One station's board read model. Like the Expo hook, the react-query cache is the source of
 * truth: the websocket writes status patches and dirty-signal invalidations into it, and polling
 * is only a safety net (tighter while the socket is down).
 */
export function useKdsStationTasks(
  locationId: number,
  stationId: number,
  options?: { enabled?: boolean }
): ReturnType<typeof useGetStationTasks<StationView>> {
  const connectionState = useOrdersWebSocketStore((s) => s.connectionState);
  return useGetStationTasks(locationId, stationId, {
    query: {
      enabled: options?.enabled ?? true,
      refetchInterval: connectionState === 'connected' ? 15_000 : 5_000,
      refetchOnWindowFocus: true,
    },
  });
}
